if (!window.klaviyoClubDownloadInitialized) {
  window.klaviyoClubDownloadInitialized = true;

  const modalId = "download-recipe-modal";
  let lastTrigger = null;

  function getModal() {
    return document.getElementById(modalId);
  }

  function closeModal() {
    const modal = getModal();

    if (!modal) {
      return;
    }

    modal.classList.remove("opened");
    modal.setAttribute("aria-hidden", "true");

    if (lastTrigger) {
      lastTrigger.focus();
      lastTrigger = null;
    }
  }

  function openModal(trigger) {
    const modal = getModal();

    if (!modal) {
      return;
    }

    const title = modal.querySelector(".download-recipe-modal-title");
    const button = modal.querySelector(
      "klaviyo-club-form [type='submit']",
    );
    const form = modal.querySelector("klaviyo-club-form");

    if (trigger.dataset.title && title) {
      title.textContent = trigger.dataset.title;
    }
    if (trigger.dataset.btn && button) {
      button.textContent = trigger.dataset.btn;
    }
    if (form) {
      form.dataset.successUrl = trigger.dataset.url || "";
      form.resetState?.();
      const downloadLink = form.querySelector('[data-club-download-link]');
      if (downloadLink) downloadLink.hidden = true;
    }

    lastTrigger = trigger;
    modal.classList.add("opened");
    modal.setAttribute("aria-hidden", "false");
    modal.focus();
  }

  document.addEventListener("click", (event) => {
    const trigger = event.target.closest(".btn-download-recipe");

    if (trigger) {
      event.preventDefault();
      openModal(trigger);
      return;
    }

    const modal = getModal();

    if (!modal) {
      return;
    }

    if (
      event.target.closest(".download-recipe-modal-toggle") ||
      event.target === modal
    ) {
      closeModal();
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && getModal()?.classList.contains("opened")) {
      closeModal();
    }
  });

  function showDownloadPreparing(downloadWindow, message) {
    if (!message) return;
    try {
      downloadWindow.document.title = message;
      downloadWindow.document.body.style.cssText = "font: 16px/1.5 system-ui, sans-serif; margin: 2rem;";
      downloadWindow.document.body.textContent = message;
    } catch {
      // The reserved tab still receives the PDF without this message.
    }
  }

  // The submit event still carries the visitor's click, so the PDF tab is reserved here: once the
  // signup has finished, the popup blocker would refuse to open it. The capture phase runs before
  // the club form's own handler, which ignores a submit while an earlier one is in flight.
  document.addEventListener("submit", (event) => {
    const form = event.target.closest?.("klaviyo-club-form");
    if (!form || form.submitting || !form.dataset.successUrl) return;

    const downloadWindow = window.open("about:blank", "_blank");
    form.downloadWindow = downloadWindow;
    if (downloadWindow) {
      downloadWindow.opener = null;
      showDownloadPreparing(downloadWindow, form.dataset.downloadPreparing);
    }
  }, true);

  function handleSubscriptionResult(event) {
    const successUrl = event.target.dataset.successUrl;
    const downloadWindow = event.target.downloadWindow;
    event.target.downloadWindow = null;

    const downloadLink = event.target.querySelector('[data-club-download-link]');
    if (downloadLink) {
      downloadLink.hidden = true;
      downloadLink.querySelector('a').removeAttribute('href');
    }

    if (successUrl && event.detail?.primarySucceeded === true) {
      if (downloadLink) {
        downloadLink.querySelector('a').href = successUrl;
        downloadLink.hidden = false;
      }
      if (downloadWindow) downloadWindow.location.replace(successUrl);
    } else {
      downloadWindow?.close();
    }
  }

  document.addEventListener("klaviyo:club-form:success", handleSubscriptionResult);
  document.addEventListener("klaviyo:club-form:partial", handleSubscriptionResult);
  document.addEventListener("klaviyo:club-form:error", handleSubscriptionResult);
}
